/**
 * MENU TOKENS
 * Source: 🔧 Custom — not defined in Figma component tokens
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createMenuTokens(s: SemanticTokens) {
  return {
  bg: s.surface.modal,                        // --menu-bg: var(--surface-modal)
  fg: s.text.secondary,                       // --menu-fg: var(--text-secondary)
  border: s.border.default,                   // --menu-border: var(--border-default)
  shadow: s.shadow.md,                        // --menu-shadow
  radius: s.radius.md,                        // --menu-radius: var(--radius-8)
  transition: s.transition.normal,              // --menu-transition
  listPadding: s.layout.padding.xs,           // --menu-list-padding
  listGap: s.layout.gap.xs,                   // --menu-list-gap
  item: {
    fg: s.text.secondary,                    // --menu-item-fg: var(--text-secondary)
    fgFocus: s.text.secondary,               // --menu-item-fg-focus
    fgSelected: s.text.secondary,              // --menu-item-fg-selected: var(--text-secondary)
    bgFocus: s.surface.canvas,               // --menu-item-bg-focus: var(--surface-canvas) = #e7e8ec
    bgSelected: s.surface.canvas,            // --menu-item-bg-selected: var(--surface-canvas) = #e7e8ec
    padding: s.layout.gap.md,                // --menu-item-padding: var(--spacing-16)
    gap: s.layout.gap.sm,                    // --menu-item-gap: var(--spacing-8)
    iconFg: s.text.muted,                    // --menu-item-icon-fg: var(--text-muted)
    iconFgFocus: s.text.secondary,           // --menu-item-icon-fg-focus
    borderRadius: s.radius.sm,               // --menu-item-border-radius
  },
  submenuLabel: {
    fg: s.text.muted,                        // --menu-submenu-label-fg
    fontWeight: s.typography.fontWeight.semibold, // --menu-submenu-label-font-weight
  },
  separator: {
    border: s.border.divider,                // --menu-separator-border: var(--border-divider)
  },
  };
}
export const menuTokens = createMenuTokens(SEMANTIC);